import { ShieldCheckIcon, ShieldMinusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { GetUserResponse } from 'sdk';
import { appConfig } from 'shared';
import { MiddleCut } from '~/modules/common/middle-cut';

interface UserProfileSublineProps {
  user: GetUserResponse;
}

/** The line below a user's name in the profile header: the email address and, from sm up where the API returns it, the MFA setting. */
export function UserProfileSubline({ user }: UserProfileSublineProps) {
  const { t } = useTranslation();

  return (
    // The text column clips: pr-1 keeps it from scrolling when the link takes focus
    <div className="text-muted-foreground flex min-w-0 items-center gap-2 pr-1">
      <a href={`mailto:${user.email}`} className="group/email focus-inset text-foreground -m-1 truncate rounded-sm p-1">
        <MiddleCut text={user.email} className="link-decoration group-active/email:link-decoration-strong group-hover/email:underline" />
      </a>
      {user.mfaRequired !== undefined && (
        <span className="flex shrink-0 items-center gap-2 max-sm:hidden">
          <span aria-hidden="true" className="text-faint-foreground">
            ·
          </span>
          <span className="flex items-center gap-1">
            {user.mfaRequired ? <ShieldCheckIcon className="size-3.5" /> : <ShieldMinusIcon className="size-3.5" />}
            {t(user.mfaRequired ? 'c:mfa_on' : 'c:mfa_off')}
          </span>
        </span>
      )}
      {appConfig.mode === 'development' && <span className="ml-2 shrink-0 text-xs max-sm:hidden">{user.id}</span>}
    </div>
  );
}
